import axios from "axios";
import { getOrigin } from "./helpers";

const instance = axios.create({
  baseURL: getOrigin(),
  headers: { Authorization: "Bearer " + localStorage.getItem("_token") },
});

export default instance;
